import { BASE_URL_V2 } from '@~/constants/api';

import actions from './index';

export const ACTIONS = {
  GET: 'DISCIPLINE_GET',
  GET_SUCCESS: 'DISCIPLINE_GET_SUCCESS',
  GET_FAILURE: 'DISCIPLINE_GET_FAILURE',
};

export const get = actions.get(
  userId => `${BASE_URL_V2}/students/${userId}/discipline/`,
  {
    PENDING: ACTIONS.GET,
    SUCCESS: ACTIONS.GET_SUCCESS,
    FAILURE: ACTIONS.GET_FAILURE,
  },
);
